// global imports
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { withLocalize } from 'react-localize-redux';
import { CircularProgress, makeStyles, Theme } from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles';
import 'react-datepicker/dist/react-datepicker.css';

// project imports
import Card from '../../../../../components/Card/Card.jsx';
import CardBody from '../../../../../components/Card/CardBody';
import CardHeader from '../../../../../components/Card/CardHeader.jsx';
import ConnectWidget from '../../../../../components/ConnectWidget/ConnectWidget';
import DisconnectWidget from '../../../../../components/DisconnectWidget/DisconnectWidget';
import { fetchOAuthUrlRequest } from '../../../../../store/actions/auth_actions';
import { testConnectionRequest } from '../../../../../store/actions/common_actions';
import commonStyles from '../../../../../assets/jss/commonStyles';

// project types imports
import { IStyleProps, PropsClasses } from '../../../../../types/StyleProps';

// local imports
import { IState } from '../../../../../store/reducers';
import { Props, StateProps } from './types';

const useStyles = makeStyles<Theme, IStyleProps>(commonStyles as StyleRules);

const ZohoBooksApp = (props: Props) => {
  const classes: PropsClasses = useStyles({} as IStyleProps);
  const dispatch = useDispatch();

  const { translate } = props;

  const OAuthURL = useSelector<IState, StateProps['OAuthURL']>(({ 'zoho-crm': { OAuthURL } }) => OAuthURL);
  const connectionStatus = useSelector<IState, StateProps['connectionStatus']>(
    ({ 'zoho-crm': { connectionStatus } }) => connectionStatus,
  );

  // didMount fetch data
  useEffect(() => {
    if (!OAuthURL) {
      dispatch(fetchOAuthUrlRequest({ system: 'zoho-crm' }));
    }

    dispatch(testConnectionRequest({ system: 'zoho-crm' }));
  }, []);

  // test connection status
  useEffect(() => {
    if (connectionStatus) {
      if (connectionStatus === 'nok' || connectionStatus === 'nook') {
        fetchOAuthUrlRequest({ system: 'zoho-crm' });
      }
    }
  }, [connectionStatus]);

  return (
    <Card>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>Sumup</h4>
      </CardHeader>
      <CardBody>
        <h3>{translate('status')}</h3>
        <div className={classes.connectRow}>
          {OAuthURL && connectionStatus !== 'loading' ? (
            connectionStatus === 'ok' ? (
              <>
                <div className={classes.connectedContainer}>
                  <span className={classes.connectedStatus}>{translate('connected')}</span>
                  <DisconnectWidget appName="zoho-crm" />
                </div>
              </>
            ) : (
              <ConnectWidget appName="zoho-crm" redirect="/admin/zoho-crm" />
            )
          ) : (
            <CircularProgress />
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default withLocalize(ZohoBooksApp);
